import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaArrowRight
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-about">
              <div className="footer-logo">
                <span className="logo-icon">IBA</span>
                <div className="logo-text">
                  <span className="logo-title">Imperial</span>
                  <span className="logo-subtitle">Badminton Academy</span>
                </div>
              </div>
              <p>
                Imperial Badminton Academy is a premier training facility dedicated to developing
                world-class badminton players through expert coaching, state-of-the-art facilities,
                and a passion for excellence.
              </p>
              <div className="footer-social">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FaFacebookF />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <FaTwitter />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <FaYoutube />
                </a>
              </div>
            </div>

            <div className="footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/"><FaArrowRight /> Home</Link></li>
                <li><Link to="/about"><FaArrowRight /> About Us</Link></li>
                <li><Link to="/services"><FaArrowRight /> Our Services</Link></li>
                <li><Link to="/our-staff"><FaArrowRight /> Our Coaches</Link></li>
                <li><Link to="/testimonials"><FaArrowRight /> Testimonials</Link></li>
                <li><Link to="/blog"><FaArrowRight /> Blog</Link></li>
                <li><Link to="/contact"><FaArrowRight /> Contact Us</Link></li>
              </ul>
            </div>

            <div className="footer-services">
              <h4>Our Programs</h4>
              <ul>
                <li><Link to="/beginner-training"><FaArrowRight /> Beginner Training</Link></li>
                <li><Link to="/Intermediate-Coaching"><FaArrowRight /> Intermediate Coaching</Link></li>
                <li><Link to="/advanced-training"><FaArrowRight /> Advanced Training</Link></li>
                <li><Link to="/Professional-Coaching"><FaArrowRight /> Professional Coaching</Link></li>
                <li><Link to="/Kids-Programs"><FaArrowRight /> Kids Programs</Link></li>
                <li><Link to="/services/membership"><FaArrowRight /> Membership Plans</Link></li>
              </ul>
            </div>

            <div className="footer-contact">
              <h4>Contact Info</h4>
              <ul>
                <li>
                  <FaMapMarkerAlt />
                  <span>Rani Talab, Jind, Haryana 126102</span>
                </li>
                <li>
                  <FaPhone />
                  <span>
                    <a href="tel:+919876543210">+91 97281 54227</a><br />
                    {/* <a href="tel:+911234567890">+91 12345 67890</a> */}
                  </span>
                </li>
                <li>
                  <FaEnvelope />
                  <span>
                    <a href="mailto:info@imperialbadminton.com">info@imperialbadminton.com</a><br />
                    {/* <a href="mailto:admissions@imperialbadminton.com">admissions@imperialbadminton.com</a> */}
                  </span>
                </li>
                {/* <li>
                  <FaClock />
                  <span>
                    Mon - Sat: 6:00 AM - 10:00 PM<br />
                    Sunday: 7:00 AM - 8:00 PM
                  </span>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Imperial Badminton Academy. All Rights Reserved.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-conditions">Terms & Conditions</Link>
              <Link to="/sitemap">Sitemap</Link>
            </div>
          </div>
        </div>
      </div> */}
    </footer>
  );
};

export default Footer;
